import { ClassesType, ClassInstanceExercisesType } from '../types/classes.type';
import { HTTPServices } from './base.service';

export type UpdateCLassExerciseProps = {
    instance_id: number;
    station_number: number;
    exercise_id: number;
    /* Optional: when absent the backend keeps the target, or clears it if the exercise changed. Empty text clears it. */
    target?: string;
}

export class ClassesServices extends HTTPServices {
    private static BASE_ROUTE = 'classes/';

    static getAll() {
        return ClassesServices.get<ClassesType[]>(ClassesServices.BASE_ROUTE);
    }

    static add(data: ClassesType) {
        return super.post<ClassesType>(ClassesServices.BASE_ROUTE, data, 'raw');
    }

    static update(data: ClassesType) {
        return super.put<ClassesType>(ClassesServices.BASE_ROUTE, data, 'raw');
    }

    static getByStudioAndDate(studioId: number, date: string) {
        return super.get<ClassesType>(ClassesServices.BASE_ROUTE + `?studio_id=${studioId}&date=${date}`);
    }

    static deleteDayClasses(data: { date: string, studio_id: number }) {
        return super.delete<ClassesType[]>(ClassesServices.BASE_ROUTE, data);
    }

    static deleteScheduleById(id: number) {
        return super.delete<ClassesType[]>(ClassesServices.BASE_ROUTE + 'schedule/' + id);
    }

    static getInstanceExercises(classId: number) {
        return super.get<ClassInstanceExercisesType[]>(ClassesServices.BASE_ROUTE + `workout/exercises?instance_id=${classId}`);
    }

    static updateClassExercise(data: UpdateCLassExerciseProps) {
        return super.put<ClassInstanceExercisesType[]>(ClassesServices.BASE_ROUTE + `workout/exercise`, data, 'raw');
    }


}
